module.exports = __webpack_public_path__ + "static/img/Aacteacher2.753dcd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aacteacher2.png
// module id = vLf6
// module chunks = 1